module.exports = __webpack_public_path__ + "static/media/youth.df2e0db2.png";